import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { SetPhase } from './set-phase.action';

export function setPhaseReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<ActionType.COACHING__CA__SET_PHASE, SetPhase>,
): CaAnalysisDialogState {
    try {
        return {
            ...state,
            phase: action.payload.phase,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
